/**
 * Session-scoped cache for Towlot catalog responses (survives full page reload; cleared on logout).
 * Match backend catalog version bumps when payload shape changes.
 */
export const TOWLOT_CATALOG_STORAGE_KEY = 'roadsider:user_towlot_catalog:v2';

/** Incremented on cache clear so in-flight catalog GETs can ignore stale completions after logout. */
let fetchEpoch = 0;
export const getTowlotCatalogFetchEpoch = () => fetchEpoch;

/** @returns {{ data: { towlot_catalog: object } } | null} axios-shaped envelope for Redux success */
export const readTowlotCatalogCachedEnvelope = () => {
  try {
    const raw = sessionStorage.getItem(TOWLOT_CATALOG_STORAGE_KEY);
    if (!raw) return null;
    const body = JSON.parse(raw);
    if (!body?.towlot_catalog || typeof body.towlot_catalog !== 'object') return null;

    return { data: body };
  } catch {
    return null;
  }
};

/** @param {{ data?: { towlot_catalog?: object } }} res - axios-like response body */
export const writeTowlotCatalogCacheFromResponse = (res) => {
  try {
    if (res?.data?.towlot_catalog) {
      sessionStorage.setItem(TOWLOT_CATALOG_STORAGE_KEY, JSON.stringify(res.data));
    }
  } catch {
    /* storage quota / private mode */
  }
};

export const clearTowlotCatalogCache = () => {
  fetchEpoch += 1;
  try {
    sessionStorage.removeItem(TOWLOT_CATALOG_STORAGE_KEY);
  } catch {
    /* noop */
  }
};
